import { render, staticRenderFns } from "./EqsColoredCard.vue?vue&type=template&id=1238cefc"
import script from "./EqsColoredCard.vue?vue&type=script&lang=js"
export * from "./EqsColoredCard.vue?vue&type=script&lang=js"
import style0 from "./EqsColoredCard.vue?vue&type=style&index=0&id=1238cefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports